// import React, { useState, useEffect } from "react";
// import Card from "../common/Card";
// import { FeatureCard } from "./FeatureCard";
// // import { FeatureCard } from "../functions/FeatureCard";
// import { ActionButton } from "../ui/ActionButton";

// /**
//  * Universal Section Component - handles all section types reactively
//  */
// export const Section = ({
//   type = "features", // "features", "status", "quickActions", "custom"
//   title,
//   subtitle,
//   icon,
//   gradient = "from-blue-600 to-indigo-600",
//   data = [],
//   actions,
//   loading = false,
//   onItemClick,
//   onRefresh,
//   compact = false,
//   className = "",
//   children,
//   // Reactive props
//   autoRefresh = false,
//   refreshInterval = 30000,
//   onDataChange,
//   gridCols = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
// }) => {
//   const [isLoading, setIsLoading] = useState(loading);
//   const [sectionData, setSectionData] = useState(data);

//   // Auto-refresh functionality
//   useEffect(() => {
//     if (autoRefresh && onRefresh) {
//       const interval = setInterval(() => {
//         onRefresh();
//       }, refreshInterval);
//       return () => clearInterval(interval);
//     }
//   }, [autoRefresh, onRefresh, refreshInterval]);

//   // Update data when prop changes
//   useEffect(() => {
//     setSectionData(data);
//     if (onDataChange) {
//       onDataChange(data);
//     }
//   }, [data, onDataChange]);

//   // Render different section types
//   const renderSectionContent = () => {
//     switch (type) {
//       case "features":
//         return (
//           <div className={`grid ${gridCols} gap-6`}>
//             {sectionData.map((item, index) => (
//               <FeatureCard
//                 key={item.id || index}
//                 title={item.title}
//                 description={item.description}
//                 onClick={() => onItemClick?.(item)}
//                 icon={item.icon}
//                 gradient={item.gradient}
//                 delay={item.delay || index * 100}
//               />
//             ))}
//           </div>
//         );

//       case "status":
//         return (
//           <div className={`grid ${gridCols} gap-4`}>
//             {sectionData.map((item, index) => (
//               <Card
//                 key={item.id || index}
//                 variant="status"
//                 title={item.title}
//                 subtitle={item.subtitle}
//                 icon={item.icon}
//                 gradient={item.gradient}
//                 onClick={() => onItemClick?.(item)}
//                 count={item.count}
//                 loading={item.loading}
//                 hover={!!onItemClick}
//               />
//             ))}
//           </div>
//         );

//       case "quickActions":
//         return (
//           <div className="flex flex-wrap justify-center gap-4">
//             {sectionData.map((item, index) => (
//               <ActionButton
//                 key={item.id || index}
//                 onClick={() => onItemClick?.(item)}
//                 variant={item.variant || "primary"}
//                 icon={item.icon}
//                 className={item.className}
//               >
//                 {item.title}
//               </ActionButton>
//             ))}
//           </div>
//         );

//       case "custom":
//         return children;

//       default:
//         return (
//           <div className={`grid ${gridCols} gap-6`}>
//             {sectionData.map((item, index) => (
//               <div key={item.id || index} className="p-4 border rounded-lg">
//                 <h3 className="font-semibold">{item.title}</h3>
//                 <p className="text-sm text-gray-600">{item.description}</p>
//               </div>
//             ))}
//           </div>
//         );
//     }
//   };

//   // Render section actions
//   const renderActions = () => {
//     if (!actions && !onRefresh) return null;

//     return (
//       <div className="flex items-center gap-2">
//         {actions}
//         {onRefresh && (
//           <ActionButton
//             onClick={onRefresh}
//             variant="secondary"
//             disabled={isLoading}
//             className="text-xs bg-white/20 hover:bg-white/30 text-white border-white/30"
//           >
//             {isLoading ? "Refreshing..." : "Refresh"}
//           </ActionButton>
//         )}
//       </div>
//     );
//   };

//   return (
//     <Card
//       variant="gradient"
//       title={title}
//       subtitle={subtitle}
//       icon={icon}
//       gradient={gradient}
//       compact={compact}
//       loading={isLoading}
//       actions={renderActions()}
//       className={className}
//     >
//       {renderSectionContent()}
//     </Card>
//   );
// };

// // Pre-configured section types for common use cases
// export const FeatureSection = (props) => (
//   <Section type="features" {...props} />
// );

// export const StatusSection = (props) => (
//   <Section type="status" gridCols="grid-cols-1 md:grid-cols-3" {...props} />
// );

// export const QuickActionsSection = (props) => (
//   <Section type="quickActions" {...props} />
// );

// export default Section;
// Section.jsx - Updated to use our new unified components
import React, { useState, useEffect } from "react";
import { Card } from "./Card"; // Use our new Card
import { FeatureCard } from "./FeatureCard";
// import { Button } from "./Button"; // Use our new unified Button
import { RefreshCw } from "lucide-react";
import { Button } from "../ui/base-components";

/**
 * Universal Section Component - Updated to use unified base components
 */
export const Section = ({
  type = "features", // "features", "status", "quickActions", "custom"
  title,
  subtitle,
  icon,
  data = [],
  actions,
  loading = false,
  onItemClick,
  onRefresh,
  className = "",
  children,
  // Grid configuration
  gridCols = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  // Auto-refresh props
  autoRefresh = false,
  refreshInterval = 30000,
  onDataChange,
}) => {
  const [isLoading, setIsLoading] = useState(loading);
  const [sectionData, setSectionData] = useState(data);

  // Auto-refresh functionality
  useEffect(() => {
    if (autoRefresh && onRefresh) {
      const interval = setInterval(() => {
        onRefresh();
      }, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [autoRefresh, onRefresh, refreshInterval]);

  // Update data when prop changes
  useEffect(() => {
    setSectionData(data);
    setIsLoading(loading);
    if (onDataChange) {
      onDataChange(data);
    }
  }, [data, loading, onDataChange]);

  // Render different section types
  const renderSectionContent = () => {
    switch (type) {
      case "features":
        return (
          <div className={`grid ${gridCols} gap-6`}>
            {sectionData.map((item, index) => (
              <FeatureCard
                key={item.id || index}
                title={item.title}
                description={item.description}
                onClick={() => onItemClick?.(item)}
                icon={item.icon}
                gradient={item.gradient}
                delay={item.delay || index * 100}
              />
            ))}
          </div>
        );

      case "status":
        return (
          <div className={`grid ${gridCols} gap-4`}>
            {sectionData.map((item, index) => (
              <Card
                key={item.id || index}
                title={item.title}
                subtitle={item.subtitle}
                icon={item.icon}
                onClick={() => onItemClick?.(item)}
                variant={item.variant || "default"}
                className="hover:shadow-lg transition-shadow cursor-pointer"
              >
                {item.count !== undefined && (
                  <div className="text-center">
                    <div className="text-3xl font-bold text-blue-600">
                      {item.loading ? '...' : item.count}
                    </div>
                    <div className="text-sm text-gray-500">Total</div>
                  </div>
                )}
                {item.content}
              </Card>
            ))}
          </div>
        );

      case "quickActions":
        return (
          <div className="flex flex-wrap gap-4">
            {sectionData.map((item, index) => (
              <Button
                key={item.id || index}
                onClick={() => onItemClick?.(item)}
                variant={item.variant || "primary"}
                icon={item.icon}
                disabled={item.disabled}
                loading={item.loading}
                className={item.className}
              >
                {item.title}
              </Button>
            ))}
          </div>
        );

      case "grid":
        return (
          <div className={`grid ${gridCols} gap-4`}>
            {sectionData.map((item, index) => (
              <Card
                key={item.id || index}
                title={item.title}
                subtitle={item.subtitle}
                icon={item.icon}
                onClick={() => onItemClick?.(item)}
                className="hover:shadow-md transition-shadow"
              >
                {item.content || (
                  <p className="text-gray-600">{item.description}</p>
                )}
              </Card>
            ))}
          </div>
        );

      case "custom":
        return children;

      default:
        return (
          <div className={`grid ${gridCols} gap-6`}>
            {sectionData.map((item, index) => (
              <div key={item.id || index} className="p-4 border rounded-lg">
                <h3 className="font-semibold">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        );
    }
  };

  // Render section actions
  const renderActions = () => {
    if (!actions && !onRefresh) return null;

    return (
      <div className="flex items-center gap-2">
        {actions}
        {onRefresh && (
          <Button
            onClick={onRefresh}
            variant="secondary"
            size="sm"
            icon={RefreshCw}
            disabled={isLoading}
            loading={isLoading}
          >
            {isLoading ? "Refreshing..." : "Refresh"}
          </Button>
        )}
      </div>
    );
  };

  return (
    <Card
      title={title}
      subtitle={subtitle}
      icon={icon}
      actions={renderActions()}
      className={className}
    >
      {isLoading && sectionData.length === 0 ? (
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-500">Loading...</p>
          </div>
        </div>
      ) : sectionData.length === 0 ? (
        <div className="text-center py-12">
          <div className="text-gray-400 mb-2">
            <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2 2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-1">No items found</h3>
          <p className="text-gray-500">There are no items to display at the moment.</p>
        </div>
      ) : (
        renderSectionContent()
      )}
    </Card>
  );
};

// Pre-configured section types for common use cases
export const FeatureSection = (props) => (
  <Section type="features" {...props} />
);

export const StatusSection = (props) => (
  <Section 
    type="status" 
    gridCols="grid-cols-1 md:grid-cols-2 lg:grid-cols-3" 
    {...props} 
  />
);

export const QuickActionsSection = (props) => (
  <Section type="quickActions" {...props} />
);

export const GridSection = (props) => (
  <Section type="grid" {...props} />
);

export default Section;